const projects = [
    {
        slug: 'jksk-wedding-case-study',
        title: 'JKSK Wedding',
        image: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_jumbotron.jpg',
        liveUrl: 'https://kkowatsch.github.io/wedding-bootstrap/',
        repoUrl: 'https://github.com/kkowatsch/wedding-bootstrap',
        caseStudyUrl: '/case-studies/wedding-bootstrap.md',
        gallery: [
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_code_global_css_ex_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_code_global_css_ex_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_code_global_css_ex_src1200.jpg',
                id: 'fig-1-0',
                alt: 'Global CSS sample demonstrating CSS custom properties and fluid typography.',
                caption: 'Fig 1.0 - Global CSS sample demonstrating CSS custom properties, fluid typography, and baseline resets used across the JKSK Wedding project.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_mobile_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_mobile_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_mobile_src1200.jpg',
                id: 'fig-2-0',
                alt: 'Asymmetric CSS Grid gallery (mobile)',
                caption: 'Fig 2.0 - Asymmetric CSS Grid gallery on mobile: single-column layout with full-width images optimized for touch interaction and mobile viewing.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_tablet_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_tablet_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_tablet_src1200.jpg',
                id: 'fig-2-1',
                alt: 'Asymmetric CSS Grid gallery (tablet)',
                caption: 'Fig 2.1 - Asymmetric CSS Grid gallery on tablet: two-column responsive layout that balances image visibility with navigation flow.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_desktop_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_desktop_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_gallery_desktop_src1200.jpg',
                id: 'fig-2-2',
                alt: 'Asymmetric CSS Grid gallery (desktop)',
                caption: 'Fig 2.2 - Asymmetric CSS Grid gallery on desktop: intricate 8-column grid with varied image sizes and aspect ratios for visual interest and story flow.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_tab_details_mobile_full_cocktails_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_tab_details_mobile_full_cocktails_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_tab_details_mobile_full_cocktails_src1200.jpg',
                id: 'fig-3-0',
                alt: 'Custom Tab System (mobile) - stacked vertical navigation for event details',
                caption: 'Fig 3.0 - Custom Tab System on mobile: stacked vertical navigation with clear active/inactive states for event details, accommodations, and schedule information.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_tab_details_desktop_full_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_tab_details_desktop_full_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_tab_details_desktop_full_src1200.jpg',
                id: 'fig-3-1',
                alt: 'Custom Tab System (desktop) - side-by-side navigation with keyboard support',
                caption: 'Fig 3.1 - Custom Tab System on desktop: side-by-side navigation panel with enhanced visual hierarchy and keyboard accessibility for guest information and logistics.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_faq_2_mobile_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_faq_2_mobile_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_faq_2_mobile_src1200.jpg',
                id: 'fig-4-0',
                alt: 'Accessible FAQ Accordion (mobile) - progressive disclosure with keyboard support',
                caption: 'Fig 4.0 - Accessible FAQ Accordion on mobile: progressive disclosure pattern with full keyboard navigation, screen reader support, and touch-friendly expand/collapse controls.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_faq_2_desktop_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_faq_2_desktop_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_faq_2_desktop_src1200.jpg',
                id: 'fig-4-1',
                alt: 'Accessible FAQ Accordion (desktop) - expanded view with ARIA labels',
                caption: 'Fig 4.1 - Accessible FAQ Accordion on desktop: expanded view with semantic HTML, ARIA labeling, and smooth state transitions for comprehensive guest support.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_google_form_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_google_form_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_google_form_src1200.jpg',
                alt: 'Google Form RSVP integration (guest responses, dietary restrictions, plus-one info)',
                caption: 'JKSK Wedding Google Form RSVP integration demonstrating seamless third-party form embedding, guest data collection, and responsive design across devices.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_home_desktop_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_home_desktop_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/jksk_wedding/jksk_home_desktop_src1200.jpg',
                alt: 'JKSK Wedding SPA desktop view (hero, navigation, event overview)',
                caption: 'JKSK Wedding single page application on desktop: complete hero, navigation, and event overview demonstrating polished visual hierarchy and user-centric interaction design.'
            }
        ]
    },
    {
        slug: 'kpk-accounting-project',
        title: 'KPK Accounting',
        image: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_jumbotron.jpg',
        liveUrl: 'https://www.kpkaccounting.com/',
        repoUrl: 'https://github.com/kkowatsch/kpkwebsite',
        caseStudyUrl: '/case-studies/kpk-accounting.md',
        gallery: [
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_desktop_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_desktop_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_desktop_src1200.jpg',
                id: 'fig-7-0',
                alt: 'KPK Accounting home page (desktop)',
                caption: 'Fig 7.0 - KPK Accounting home page on desktop: hero, navigation, and service overview with clear call-to-action and responsive layout.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_open_nav_mobile_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_open_nav_mobile_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_open_nav_mobile_src1200.jpg',
                id: 'fig-3-0',
                alt: 'KPK navigation menu (mobile)',
                caption: 'Fig 3.0 - KPK Accounting navigation menu on mobile: accessible hamburger toggle, vertical links, and touch-friendly spacing for small screens.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_contact_mobile_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_contact_mobile_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_contact_mobile_src1200.jpg',
                id: 'fig-1-0',
                alt: 'KPK contact page (mobile)',
                caption: 'Fig 1.0 - KPK Accounting contact page on mobile: focused form layout with inline validation and clear feedback for user submissions.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_intro_mobile_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_intro_mobile_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_intro_mobile_src1200.jpg',
                id: 'fig-8-0',
                alt: 'KPK introduction section (mobile)',
                caption: 'Fig 8.0 - KPK Accounting introduction section on mobile: concise business summary and value proposition, optimized for readability.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_services_flipcard_mobile_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_services_flipcard_mobile_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_home_services_flipcard_mobile_src1200.jpg',
                id: 'fig-4-0',
                alt: 'KPK services flipcard (mobile)',
                caption: 'Fig 4.0 - KPK Accounting services flipcard on mobile: interactive card UI for service details, designed for clarity and engagement.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_struct_example_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_struct_example_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_struct_example_src1200.jpg',
                id: 'fig-2-0',
                alt: 'Go structs for form handling (code snippet)',
                caption: 'Fig 2.0 - Go code sample: struct definitions for robust form handling and validation in the KPK Accounting backend.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_form_template_code_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_form_template_code_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_form_template_code_src1200.jpg',
                id: 'fig-2-1',
                alt: 'HTML template for contact form (code snippet)',
                caption: 'Fig 2.1 - HTML template code: semantic markup for the KPK Accounting contact form, supporting accessibility and error display.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_form_flipcard_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_form_flipcard_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_form_flipcard_src1200.jpg',
                id: 'fig-6-0',
                alt: 'KPK Figma services flipcard design',
                caption: 'Fig 6.0 - Figma design: KPK Accounting services flipcard component, showing visual design and interaction states.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_form_text_input_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_form_text_input_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_form_text_input_src1200.jpg',
                id: 'fig-6-1',
                alt: 'KPK Figma contact form text input design',
                caption: 'Fig 6.1 - Figma design: KPK Accounting contact form text input, with focus and error states for usability.'
            },
            {
                src400: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_style_src400.jpg',
                src800: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_style_src800.jpg',
                src1200: 'https://storage.googleapis.com/kayko_design_portfolio/KPK%20Accounting/kpk_figma_style_src1200.jpg',
                id: 'fig-5-0',
                alt: 'KPK Figma style guide (fonts and colors)',
                caption: 'Fig 5.0 - Figma style guide: KPK Accounting project fonts, color palette, and design tokens for consistent branding.'
            }
        ]
    },
];

export default projects;
